import styled from '@emotion/styled';
import {
    zIndexes,
    mediaQuery,
    breakpoints,
    fontSizes,
    fontWeights,
    lineHeights,
    colors,
    colorVariables,
} from '@gumtree/ui-library/src/base/theme';

export const NavPlaceholder = styled.div<{ height: number }>`
    width: 100%;
    height: ${({ height }) => height}px;
    display: none;
`;

export const NavWrapper = styled.nav<{ isFixed: boolean; fixedTop: number }>`
    width: 100%;
    
    &::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera */
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    ${({ isFixed, fixedTop }) =>
        isFixed
            ? `
        position: fixed;
        top: ${fixedTop}px;
        left: 0;
        right: 0;
        width: 100%; // 固定时宽度设为100%
        margin-top: 0;
        z-index: ${zIndexes.medium};
        `
            : `
        position: relative; // 或者 static，取决于原始布局
        margin-top: 16px;
        `}

    background-color: ${colorVariables.backgroundNeutral};
    border-bottom: 1px solid ${colors.newBorder};


    ${mediaQuery.from(breakpoints.medium)} {
    }
`;

export const TabList = styled.ul`
    display: flex;
    justify-content: space-between;
    list-style: none;
    margin: 0;
    padding: 0;
    overflow-x: auto;
    
    &::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera */
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
`;

export const TabItem = styled.li<{ isActive: boolean }>`
    padding: 13px 16px;
    cursor: pointer;
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.normal};
    line-height: ${lineHeights.base};
    font-weight: ${({ isActive }) => (isActive ? 'bold' : 'normal')};
    color: ${({ isActive }) => (isActive ? colorVariables.mainSecondary : colorVariables.textNeutral)};
    border-bottom: 2px solid ${({ isActive }) => (isActive ? colors.gree20 : 'transparent')};
    white-space: nowrap;

    &:hover {
        color: ${colorVariables.textLink};
    }
`;
